<template>
  <div id="app">
    <Spinner v-if="this.$store.state.general.isLoading > 0" />
    <AuthenticationModal />
    <router-view :key="$route.params.lang" />
  </div>
</template>

<script>
import Spinner from '@/components/Spinner';
import AuthenticationModal from '@/components/Auth/AuthenticationModal';

export default {
  name: 'App',
  components: {
    Spinner,
    AuthenticationModal,
  },
};
</script>
